import { render } from "./RecommendPointRank2.vue?vue&type=template&id=0e40d4f9&scoped=true"
const script = {}

import "./RecommendPointRank2.vue?vue&type=style&index=0&id=0e40d4f9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e40d4f9"]])

export default __exports__